import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Mapa from "./components/Mapa";
import Sobre from "./components/Sobre";
import Casos from "./components/Casos";

// Os ids ficam no endereço (#casos/EXP003), então não mudam com os nomes.
// O nome curto é o que cabe na barra do celular.
const ABAS = [
  { id: "mapa", nome: "Radar de conflitos", curto: "Radar" },
  { id: "casos", nome: "Experiências de planejamento", curto: "Experiências" },
  { id: "sobre", nome: "Sobre", curto: "Sobre" },
];

// Marca do observatório: duas ruas que se cruzam e o ponto de conflito no cruzamento.
function Marca() {
  return (
    <svg className="marca-simbolo" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M2 9h20M15 2v20" />
      <circle cx="15" cy="9" r="4" />
    </svg>
  );
}

function App() {
  // A aba fica no endereço (#sobre, #casos/EXP003) para que o link possa ser
  // compartilhado.
  const abaDoEndereco = () => {
    const aba = window.location.hash.slice(1).split("/")[0];
    return ABAS.some((a) => a.id === aba) ? aba : "mapa";
  };
  const [aba, setAba] = useState(abaDoEndereco);
  const [categoriaInicial, setCategoriaInicial] = useState("todos");

  useEffect(() => {
    const aoMudar = () => setAba(abaDoEndereco());
    window.addEventListener("hashchange", aoMudar);
    return () => window.removeEventListener("hashchange", aoMudar);
  }, []);

  // O mapa precisa da página travada na altura da tela; o Sobre rola normalmente.
  useEffect(() => {
    document.documentElement.classList.toggle("pagina-rolavel", aba === "sobre");
    window.scrollTo(0, 0);
  }, [aba]);

  function irPara(novaAba, categoria = "todos") {
    setCategoriaInicial(categoria);
    setAba(novaAba);
    window.history.replaceState(null, "", novaAba === "mapa" ? " " : `#${novaAba}`);
  }

  return (
    <div className="app-container">
      <header className="topo">
        <a
          className="marca"
          href="#mapa"
          aria-label="Conflitos Urbanos"
          onClick={(e) => {
            e.preventDefault();
            irPara("mapa");
          }}
        >
          <Marca />
          <span className="marca-nome">Conflitos <span className="marca-destaque">Urbanos</span></span>
        </a>
        <nav className="abas" aria-label="Seções do observatório">
          {ABAS.map(({ id, nome, curto }) => (
            <button
              key={id}
              type="button"
              className={`aba ${aba === id ? "ativa" : ""}`}
              aria-current={aba === id ? "page" : undefined}
              aria-label={nome}
              onClick={() => irPara(id)}
            >
              <span className="aba-nome" aria-hidden="true">{nome}</span>
              <span className="aba-curto" aria-hidden="true">{curto}</span>
            </button>
          ))}
        </nav>
      </header>

      <main className="main-content">
        {aba === "mapa" && <Mapa categoriaInicial={categoriaInicial} />}
        {aba === "casos" && <Casos />}
        {aba === "sobre" && <Sobre abrirMapa={(categoria) => irPara("mapa", categoria)} />}
      </main>
    </div>
  );
}

export default App;
